import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PasswordSharedComponent } from './password.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { InputSharedModule } from '../input/input.module';

@NgModule({
    declarations: [
        PasswordSharedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,

        IconSharedModule,
        InputSharedModule
    ],
    exports: [
        PasswordSharedComponent
    ]
})

export class PasswordSharedModule {}
